/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// component
import FlowControls from 'material/embeds/flowcontrols/flowcontrols';



/* ========== ~~~~~~~~~~ FLOW CONTROLS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
    // currentStepPage: embedsState.embedManagementState.embedManagementStatus.currentStepPage,
    isNewEmbedFlow: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isNewEmbedFlow,
    // isSavingData: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isSavingData,
    // embedChangeDetected: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedChangeDetected,
    // contentChangeDetected: embedsState.embedManagementState.contentStatus.contentChangeDetected
});

// map actions
// const mapDispatchToProps = dispatch => ({
//
// });



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    // mapDispatchToProps
)(FlowControls);
